import { Container, FloraProvider, globalCss } from '@grupoboticario/flora-react'
import Footer from './components/Footer'
import { RouterProvider } from 'react-router-dom'
import { router } from './config/router'
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'GTM-M8P758X'
}

TagManager.initialize(tagManagerArgs)

const globalStyle = globalCss({
  'html body': { background: '#F5F5F5' },
  'html body *': { fontFamily: "'IBM Plex Sans', sans-serif !important" },
  'html, body, body > div:first-child, div#__next, div#__next > div': {
    height: '100%'
  },
  '.d-block': { display: 'block' },
  '.text1': { fontSize: '14px', lineHeight: '16px' },
  '.text2': { fontSize: '10px', lineHeight: '16px', textTransform: 'uppercase', color: '#515151' },
  '.text3': { fontSize: '16px', lineHeight: '20px' },
  'div.toggled': { display: 'block', position: 'relative' },
  'div.closed': { maxHeight: '215px', overflow: 'hidden' },
  'div.closed .gradient': {
    display: 'block',
    position: 'absolute',
    height: '70px',
    width: '100%',
    background: 'linear-gradient(to bottom, transparent, white)',
    margin: 0,
    bottom: 0
  }
})

function App() {
  globalStyle()

  return (
    <FloraProvider>
      <Container
        centerContent
        size="large"
        css={{ paddingBottom: '30px' }}
        className={`env-${process.env.REACT_APP_ENV}`}
      >
        <RouterProvider router={router} />
        <Footer />
      </Container>
    </FloraProvider>
  )
}

export default App
